import script from "./TheDecree.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDecree.vue?vue&type=script&setup=true&lang=js"

import "./TheDecree.vue?vue&type=style&index=0&id=2631ecd8&lang=scss"

const __exports__ = script;

export default __exports__